import React, { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { BulkFulfillmentPlanTagDropdown } from './bulk-tags-dropdown';
import FulfillmentPlanTagsContextProvider from './tag-context';
import { ResponsiveTagList } from '../../../../components/responsive-tag-list';
import { emptyArray } from 'ui-components/default-props/empty';
import { useFulfillmentPlanIdContext } from '../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useEntitiesFulfillmentPlanProperty } from '../../../../hooks/entities/selectors/fulfillment-plans';
import Global from '../../../../store/global-selectors';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';

import style from './tags.module.less';
import buttonTextStyle from 'ui-components/components/button/button-text.module.less';

export const Tags = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const salesOrderId = useSalesOrderIdContext();

  const fulfillmentPlanTagIds = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'tagIds') || emptyArray;

  const allSellerTags = useSelector(Global.selectSellerTags) || emptyArray;

  const fulfillmentPlanTags = useMemo(() => {
    return fulfillmentPlanTagIds.reduce((acc, tagId) => {
      const tag = allSellerTags.find((sellerTag) => sellerTag.tagId === tagId);
      if (tag) {
        acc.push(tag);
      }
      return acc;
    }, []);
  }, [fulfillmentPlanTagIds, allSellerTags]);

  return (
    <div className={style['fulfillment-plan-tags']}>
      <FulfillmentPlanTagsContextProvider
        fulfillmentPlanId={fulfillmentPlanId}
        fulfillmentPlanTags={fulfillmentPlanTags}
        salesOrderId={salesOrderId}
        sellerTags={allSellerTags}
      >
        <BulkFulfillmentPlanTagDropdown
          dropdownMenuClassName={style['fulfillment-plan-tags-dropdown-menu']}
          dropdownMenuTogglerClass={buttonTextStyle['button-text']}
        />
      </FulfillmentPlanTagsContextProvider>
      <ResponsiveTagList tags={fulfillmentPlanTags} />
    </div>
  );
};
